<template>
  <div id="dashboard" class="container-fluid px-0">
    <!-- Titulo -->
    <section id="seccionCabecera" class="w-100">
      <p class="ps-lg-4 mb-4">
        <span class="fas fa-users-cog fa-lg icon-hover-grow pt-2"></span>
        <span id="cabeceraDashboard" class="text-dark mb-0 h3 pl-2">Gestión de Suscriptores a Broadcast</span>
      </p>

      <div class="ps-lg-4 mb-4 d-flex justify-content-between align-items-center flex-wrap">
        <div class="btn-group custom-orange-group mb-4" role="group" aria-label="Vista de suscriptores">
          <button type="button" class="btn"
                  :class="viewMode === 'subscribers' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="cambiarVista('subscribers')">
            Suscriptores Activos
          </button>
          <button type="button" class="btn"
                  :class="viewMode === 'requests' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="cambiarVista('requests')">
            Solicitudes Pendientes
            <span v-if="conjuntoSolicitudes.length"
                  class="badge bg-danger ms-1 align-middle">{{ conjuntoSolicitudes.length }}</span>
          </button>
          <button type="button" class="btn"
                  :class="viewMode === 'history' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="cambiarVista('history')">
            Historial
          </button>
          <button type="button" class="btn"
                  :class="viewMode === 'whitelist' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="cambiarVista('whitelist')">
            Soporte técnico
          </button>
        </div>

        <div class="panic-container border rounded p-2 mb-4 d-flex align-items-center bg-light">
          <div class="btn-group" role="group">
            <button class="btn" :class="panicModeSms ? 'btn-danger' : 'btn-success'"
                    @click="confirmPanic('sms', !panicModeSms)">
              <i class="fas fa-sms me-1"></i>
              SMS: {{ !panicModeSms ? 'ACTIVO' : 'INACTIVO' }}
            </button>
            <button class="btn" :class="panicModeEmail ? 'btn-danger' : 'btn-success'"
                    @click="confirmPanic('email', !panicModeEmail)">
              <i class="fas fa-envelope me-1"></i>
              Emails: {{ !panicModeEmail ? 'ACTIVO' : 'INACTIVO' }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Tabla de suscriptores existentes -->
    <section class="row" id="fila_suscriptores" v-show="viewMode === 'subscribers'">
      <div class="col-xl-12 mb-5">
        <div class="tabla-scroll">
          <table id="tabla-suscriptores" class="table table-striped table-hover text-dark tabla-subcriptores">
            <colgroup>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
            </colgroup>
            <thead>
            <tr class="cabecera-agrupada align-middle">
              <th colspan="2"></th>

              <th class="px-2">
                <b-form-input size="sm" v-model="emailSearch" placeholder="Filtrar email..."
                              @keyup="debounce(consultarSuscriptores)"></b-form-input>
              </th>

              <th class="px-2">
                <b-form-input size="sm" v-model="phoneSearch" placeholder="Filtrar teléfono..."
                              @keyup="debounce(consultarSuscriptores)"></b-form-input>
              </th>

              <th></th>
              <th></th>

              <th colspan="2" class="text-center bg-light separador-vertical">
                <b>TIPOS DE ALERTA</b>
              </th>

              <th colspan="2" class="text-center bg-channels separador-vertical">
                <b>CANALES</b>
              </th>
            </tr>
            <tr class="cabecera-secundaria">
              <th>Borrar</th>
              <th>Editar</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Empresa</th>
              <th class="text-center">No molestar</th>
              <th class="text-center separador-vertical">Emergencia</th>
              <th class="text-center">Crítica</th>
              <th class="espacio-separacion text-center separador-vertical">SMS</th>
              <th class="text-center">Email</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) of conjuntoSuscriptores" v-bind:key="item.id" class="user-tabla">
              <td data-title="Borrar">
                <img class="icon-hover-grow" src="../assets/papelera-de-reciclaje.png" alt="" width="21" height="21"
                     v-on:click="activaModal(index)">
              </td>
              <td data-title="Editar">
                <span v-if="!item.isEditing" class="fas fa-edit fa-lg icon-hover-grow pt-1 text-black"
                      v-on:click="editarSuscriptor(index)"></span>
                <span v-else class="fas fa-save fa-lg icon-hover-grow pt-1 text-black"
                      v-on:click="actualizarDatos(index)"></span>
              </td>
              <td data-title="Email">
                <span v-if="!item.isEditing">{{ item.email }}</span>
                <input v-else type="email" v-model="item.email" class="form-control form-control-sm"
                       placeholder="Email">
              </td>
              <td data-title="Teléfono">
                <span v-if="!item.isEditing">{{ item.telefono }}</span>
                <input v-else type="text" v-model="item.telefono" class="form-control form-control-sm"
                       placeholder="Teléfono (Opcional)">
              </td>
              <td data-title="Empresa">{{ mostrarEmpresa(item.empresa) }}</td>
              <td data-title="No molestar">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" :class="{ active: item.do_not_disturb }"
                          disabled
                          title="Solo el usuario puede cambiar No molestar"
                          type="button"></button>
                </div>
              </td>
              <td data-title="Emergencia" class=" separador-vertical">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle" :class="{ active: item.emergencia }"
                          v-on:click="cambiarIncidencia(index, 'Emergencia')"></button>
                </div>
              </td>
              <td data-title="Crítica" class="">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle" :class="{ active: item.critica }"
                          v-on:click="cambiarIncidencia(index, 'Crítica')"></button>
                </div>
              </td>
              <td data-title="SMS" class=" espacio-separacion separador-vertical">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle" :class="{ active: item.sms }"
                          v-on:click="cambiarCanal(index, 'sms')"></button>
                </div>
              </td>
              <td data-title="Email Canal" class="">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle" :class="{ active: item.emailCanal }"
                          v-on:click="cambiarCanal(index, 'email')"></button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

          <BModal v-model="modalBorrado"
                  title="Confirmación de borrado"
                  @ok="borrar(indexBorrado)">
            ¿Estás seguro de que quieres borrar este suscriptor?
            {{ emailBorrado }}
          </BModal>

          <BModal v-model="modalError"
                  :title="tituloError"
                  ok-only>
            {{ mensajeError }}
          </BModal>

          <!-- Tabla para crear nuevo suscriptor -->
          <div class="tabla-scroll">
          <table id="tabla-subcriptores-nuevo"
                 class="table table-striped table-hover text-dark mt-4 tabla-subcriptores">
            <colgroup>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
            </colgroup>
            <thead>
            <tr class="cabecera-agrupada">
              <th colspan="4"></th>
              <th colspan="2" class="text-center bg-light separador-vertical"><b>TIPOS DE ALERTA</b></th>
              <th colspan="2" class="text-center bg-channels separador-vertical"><b>CANALES</b></th>
            </tr>
            <tr class="cabecera-secundaria">
              <th>Guardar</th>
              <th></th>
              <th>Email</th>
              <th>Teléfono</th>
              <th class="text-center separador-vertical">Emergencia</th>
              <th class="text-center">Crítica</th>
              <th class="espacio-separacion text-center separador-vertical">SMS</th>
              <th class="text-center">Email</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td data-title="Guardar"><img class="icon-hover-grow" src="../assets/disco-flexible.png" alt="" width="18"
                                            height="18" v-on:click="guardar()"></td>
              <td></td>
              <td data-title="Email">
                <input type="email" v-model="newSuscriptor.email" class="form-control form-control-sm"
                       placeholder="Email">
              </td>
              <td data-title="Teléfono"><input type="text" v-model="newSuscriptor.telefono"
                                               class="form-control form-control-sm"
                                               placeholder="Teléfono (Opcional)"></td>
              <td data-title="Emergencia" class=" separador-vertical">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle" :class="{ active: newSuscriptor.emergencia }"
                          v-on:click="cambiarNewIncidencia('Emergencia')"></button>
                </div>
              </td>
              <td data-title="Crítica" class="">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle" :class="{ active: newSuscriptor.critica }"
                          v-on:click="cambiarNewIncidencia('Crítica')"></button>
                </div>
              </td>
              <td data-title="SMS" class=" espacio-separacion separador-vertical">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle" :class="{ active: newSuscriptor.sms }"
                          v-on:click="cambiarNewCanal('sms')"></button>
                </div>
              </td>
              <td data-title="Email Canal" class="">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle" :class="{ active: newSuscriptor.emailCanal }"
                          v-on:click="cambiarNewCanal('email')"></button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          </div>
      </div>
    </section>

    <!-- Solicitudes Pendientes -->
    <section class="row" id="fila_solicitudes" v-show="viewMode === 'requests'">
      <div class="col-xl-12 mb-5">
        <div class="tabla-scroll">
          <table id="tabla-solicitudes" class="table table-striped table-hover text-dark tabla-subcriptores">
            <colgroup>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
              <col>
            </colgroup>
            <thead>
            <tr class="cabecera-agrupada">
              <th colspan="4"></th>
              <th colspan="2" class="text-center bg-light separador-vertical"><b>TIPOS DE ALERTA</b></th>
              <th colspan="2" class="text-center bg-channels separador-vertical"><b>CANALES</b></th>
            </tr>
            <tr class="cabecera-secundaria">
              <th class="text-center">Aprobar</th>
              <th class="text-center">Rechazar</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th class="text-center separador-vertical">Emergencia</th>
              <th class="text-center">Crítica</th>
              <th class="espacio-separacion text-center separador-vertical">SMS</th>
              <th class="text-center">Email</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="req in conjuntoSolicitudes" :key="req.id" class="user-tabla">
              <td data-title="Aprobar" class="text-center">
                <b-button variant="success" size="sm" @click="aprobarSolicitud(req.id)">
                  Aprobar
                </b-button>
              </td>
              <td data-title="Rechazar" class="text-center">
                <b-button variant="danger" size="sm" @click="prepararRechazo(req.id)">
                  Rechazar
                </b-button>
              </td>
              <td data-title="Email">{{ req.email }}</td>
              <td data-title="Teléfono">{{ req.phone || '-' }}</td>
              <td data-title="Emergencia" class="separador-vertical">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle"
                          :class="{ active: req.parsedChannels.includes('Emergencia') }"></button>
                </div>
              </td>
              <td data-title="Crítica">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle"
                          :class="{ active: req.parsedChannels.includes('Crítica') }"></button>
                </div>
              </td>
              <td data-title="SMS" class="espacio-separacion separador-vertical">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle"
                          :class="{ active: req.parsedMethods.includes('sms') }"></button>
                </div>
              </td>
              <td data-title="Email Canal">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" id="toggle"
                          :class="{ active: req.parsedMethods.includes('email') }"></button>
                </div>
              </td>
            </tr>
            <tr v-if="conjuntoSolicitudes.length === 0">
              <td colspan="8" class="text-center py-4 bg-white" style="text-align: center !important;">
                <span class="text-white">No hay solicitudes pendientes</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <BModal v-model="modalRechazo"
            title="Rechazar Solicitud"
            @ok="confirmarRechazo">
      <div class="form-group">
        <label for="motivoRechazo">Motivo del rechazo (opcional):</label>
        <textarea id="motivoRechazo" v-model="motivoRechazo" class="form-control" rows="3"></textarea>
      </div>
    </BModal>

    <!-- Historial de Peticiones -->
    <section class="row" v-show="viewMode === 'history'">
      <div class="col-xl-12 mb-5">
        <div class="tabla-scroll">
          <table id="tabla-historial" class="table table-striped text-dark tabla-subcriptores">
            <colgroup>
              <col style="width: 100px;">
              <col style="width: 150px;">
              <col>
              <col style="width: 150px;">
              <col style="width: 140px;">
            </colgroup>
            <thead>
            <tr class="cabecera-secundaria">
              <th>Información</th>
              <th>Estado</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th class="text-center">Fecha</th>
            </tr>
            <tr class="cabecera-filtros">
              <th></th>
              <th>
                <b-form-select size="sm" v-model="historyStatusFilter" @change="consultarHistorial">
                  <option value="Todas">Todas</option>
                  <option value="PENDING">PENDING</option>
                  <option value="APPROVED">APPROVED</option>
                  <option value="REJECTED">REJECTED</option>
                </b-form-select>
              </th>
              <th>
                <b-form-input size="sm" v-model="historyEmailSearch" placeholder="Filtrar email..."
                              @keyup="debounce(consultarHistorial)"></b-form-input>
              </th>
              <th>
                <b-form-input size="sm" v-model="historyPhoneSearch" placeholder="Filtrar teléfono..."
                              @keyup="debounce(consultarHistorial)"></b-form-input>
              </th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="req in conjuntoHistorial" :key="req.id" class="user-tabla">
              <td data-title="Información" class="text-center">
                <b-button variant="dark" size="sm" @click="abrirModalDetalles(req)">
                  Ver detalle
                </b-button>
              </td>
              <td data-title="Estado">
                {{ req.status }}
              </td>
              <td data-title="Email">{{ req.email }}</td>
              <td data-title="Teléfono">{{ req.phone || '-' }}</td>
              <td data-title="Fecha" class="text-center">
                {{ req.processed_at ? new Date(req.processed_at).toLocaleDateString() : '-' }}
              </td>
            </tr>
            <tr v-if="conjuntoHistorial.length === 0">
              <td colspan="5" class="text-center py-4 bg-white" style="text-align: center !important;">
                <span class="text-white">No hay registros en el historial</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <section class="row" id="fila_whitelist" v-show="viewMode === 'whitelist'">
      <div class="col-xl-12 mb-5">

        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 px-2">
          <h6 class="text-dark mb-2 mb-md-0 fw-bold">
            <i class="fas fa-shield-alt text-warning me-2"></i>Lista de soporte técnico
          </h6>
          <div class="d-flex gap-2 align-items-center">
            <b-form-input size="sm" v-model="newWhitelistEmail" placeholder="Añadir email..."
                          @keyup.enter="addToWhitelist" style="min-width: 300px;"></b-form-input>
            <b-button size="sm" variant="primary orange" class="text-nowrap" @click="addToWhitelist">
              <i class="fas fa-plus me-1"></i> Añadir
            </b-button>
          </div>
        </div>

        <div class="tabla-scroll">
          <table id="tabla-whitelist" class="table table-striped table-hover text-dark tabla-subcriptores">
            <colgroup>
              <col style="width: 80px;">
              <col style="width: 200px; text-align: left">
              <col style="width: 150px;">
              <col style="width: 220px;">
            </colgroup>
            <thead>
            <tr class="cabecera-secundaria">
              <th class="text-center">Borrar</th>
              <th style="text-align: left">Email</th>
              <th>Teléfono</th>
              <th class="text-center">Recibir Alertas</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in conjuntoWhitelist" :key="item.user_id" class="user-tabla">
              <td data-title="Borrar" class="text-center">
                <img class="icon-hover-grow" src="../assets/papelera-de-reciclaje.png" alt="Borrar" width="21"
                     height="21" @click="removeFromWhitelist(item.user_id)">
              </td>
              <td data-title="Email" style="text-align: left">{{ item.email }}</td>
              <td data-title="Teléfono">{{ item.phone || '-' }}</td>
              <td data-title="Recibir Alertas">
                <div class="toggle-container mx-auto">
                  <button class="toggle-button" :class="{ active: item.is_active === 1 }"
                          @click="toggleWhitelistStatus(item.user_id)"></button>
                </div>
              </td>
            </tr>
            <tr v-if="conjuntoWhitelist.length === 0">
              <td colspan="4" class="text-center py-4 bg-white" style="text-align: center !important;">
                <span class="text-muted">No hay usuarios en la lista blanca. Las alertas de pánico detendrán todos los envíos.</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </section>

    <!-- Modales de Pánico -->
    <BModal v-model="modalPanicEmail" @ok="updatePanicConfig('email')">

      <template #title>
        <i class="fas fa-exclamation-triangle ms-1" :class="pendingPanicValue ? 'text-danger' : 'text-warning'"></i>
        Confirmar cambio de configuración Email
      </template>

      <div class="alert" :class="pendingPanicValue ? 'alert-danger' : 'alert-warning'">
        Esto <strong>{{ pendingPanicValue ? 'DETENDRÁ' : 'REANUDARÁ' }}</strong> todas las comunicaciones
        de <strong>EMAIL</strong>.
        <br><br>
        {{
          pendingPanicValue
              ? 'Solo los usuarios en la lista de soporte técnico recibirán notificaciones.'
              : 'Los usuarios volveran a recibir comunicaciones'
        }}
      </div>
    </BModal>

    <BModal v-model="modalPanicSms" @ok="updatePanicConfig('sms')">

      <template #title>
        <i class="fas fa-exclamation-triangle ms-1" :class="pendingPanicValue ? 'text-danger' : 'text-warning'"></i>
        Confirmar cambio de configuración SMS
      </template>

      <div class="alert" :class="pendingPanicValue ? 'alert-danger' : 'alert-warning'">
        Esto <strong>{{ pendingPanicValue ? 'DETENDRÁ' : 'REANUDARÁ' }}</strong> todas las comunicaciones
        de <strong>SMS</strong>.
        <br><br>
        {{
          pendingPanicValue
              ? 'Solo los usuarios en la lista de soporte técnico recibirán notificaciones.'
              : 'Los usuarios volveran a recibir comunicaciones'
        }}
      </div>
    </BModal>

    <!-- Modal de Detalles (Estilo CuadroMando) -->
    <BModal v-model="modalDetallesVisible" size="lg" scrollable title="Detalles de la Solicitud">
      <div class="container px-0">
        <table class="table table-hover">
          <tbody>
          <tr>
            <th>Email:</th>
            <td>{{ solicitudSeleccionada.email }}</td>
          </tr>
          <tr>
            <th>Teléfono:</th>
            <td>{{ solicitudSeleccionada.phone || '-' }}</td>
          </tr>
          <tr>
            <th>Fecha Procesado:</th>
            <td>{{ formatearFecha(solicitudSeleccionada.processed_at) }}</td>
          </tr>
          <tr>
            <th>Estado:</th>
            <td :class="solicitudSeleccionada.status === 'REJECTED' ? 'text-danger fw-bold' : 'text-success fw-bold'">
              {{ solicitudSeleccionada.status }}
            </td>
          </tr>
          <tr v-if="solicitudSeleccionada.status !== 'PENDING'">
            <th>Procesado por (Admin):</th>
            <td>{{ solicitudSeleccionada.processed_by }}</td>
          </tr>
          <tr v-if="solicitudSeleccionada.status === 'REJECTED' && solicitudSeleccionada.rejection_reason">
            <th>Motivo del Rechazo:</th>
            <td>{{ solicitudSeleccionada.rejection_reason }}</td>
          </tr>
          <tr>
            <th>Canales Solicitados:</th>
            <td>{{ solicitudSeleccionada.parsedChannels?.join(', ') }}</td>
          </tr>
          <tr>
            <th>Medios Solicitados:</th>
            <td>{{ solicitudSeleccionada.parsedMethods?.join(', ') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <b-button variant="secondary" @click="modalDetallesVisible = false">Cerrar</b-button>
        <b-button v-if="solicitudSeleccionada.status === 'REJECTED'" variant="primary orange"
                  @click="aprobarHistorial(solicitudSeleccionada.id)">
          Aceptar Solicitud
        </b-button>
      </template>
    </BModal>
  </div>
</template>

<script>
import auth from '../auth.js';
import {BModal} from "bootstrap-vue-next";

class Suscriptor {
  constructor(email, telefono, emergencia, critica, sms, emailCanal) {
    this.email = email
    this.telefono = telefono
    this.emergencia = emergencia
    this.critica = critica
    this.sms = sms
    this.emailCanal = emailCanal
  }
}

export default {
  components: {BModal},
  data() {
    return {
      newSuscriptor: new Suscriptor(null, null, 0, 0, 0, 0),
      conjuntoSuscriptores: [],
      modalBorrado: false,
      indexBorrado: 1e6,
      emailBorrado: '',
      modalError: false,
      mensajeError: '',
      tituloError: 'Error',
      viewMode: 'subscribers',
      conjuntoSolicitudes: [],
      conjuntoHistorial: [],
      modalVerMotivo: false,
      motivoSeleccionado: '',
      modalRechazo: false,
      idRechazoActivo: null,
      motivoRechazo: '',
      modalDetallesVisible: false,
      solicitudSeleccionada: {},
      // Filtros
      emailSearch: '',
      phoneSearch: '',
      historyEmailSearch: '',
      historyPhoneSearch: '',
      historyStatusFilter: 'REJECTED',
      debounceTimeout: null,
      // Pánico y Whitelist
      panicModeEmail: false,
      panicModeSms: false,
      conjuntoWhitelist: [],
      newWhitelistEmail: '',
      modalPanicEmail: false,
      modalPanicSms: false,
      pendingPanicValue: false
    }
  },
  created() {
    this.consultarSuscriptores();
    this.consultarSolicitudes();
    this.consultarHistorial();
    this.getPanicConfig();
    this.getWhitelist();
    this.$store.state.botonEditar = false;
    this.$store.state.editar = false;
  },
  mounted() {
  },
  methods: {
    activaModal(index) {
      this.indexBorrado = index;
      this.emailBorrado = this.conjuntoSuscriptores[this.indexBorrado].email;
      this.modalBorrado = true;
    },

    editarSuscriptor(index) {
      this.conjuntoSuscriptores[index].isEditing = true;
    },

    async actualizarDatos(index) {
      const item = this.conjuntoSuscriptores[index];
      if (!item.email) {
        this.tituloError = 'Error de validación';
        this.mensajeError = 'El Email es obligatorio';
        this.modalError = true;
        return;
      }

      // Regla: Si SMS activo, teléfono obligatorio
      if (item.sms === 1 && (!item.telefono || item.telefono.trim() === '')) {
        this.tituloError = 'Error de validación';
        this.mensajeError = 'El teléfono es obligatorio para activar notificaciones por SMS.';
        this.modalError = true;
        return;
      }

      try {
        const response = await fetch(`/api/subscribers`, {
          method: 'PUT',
          headers: auth.getAuthHeader(),
          body: JSON.stringify({
            userId: item.id,
            email: item.email,
            telefono: item.telefono || null
          })
        });

        if (response.status === 200) {
          item.isEditing = false;
          await this.consultarSuscriptores();
        } else {
          const data = await response.json();
          this.tituloError = 'Error en la operación';
          this.mensajeError = data.resultado || 'Error al actualizar suscriptor';
          this.modalError = true;
        }
      } catch (error) {
        console.error("Error al actualizar suscriptor:", error);
        this.tituloError = 'Error en la operación';
        this.mensajeError = 'Error al actualizar suscriptor';
        this.modalError = true;
      }
    },

    // Convierte formato del backend al frontend
    parsearSuscriptor(suscriptor) {
      const emergencia = suscriptor.suscripciones.tipos_incidencias.includes('Emergencia') ? 1 : 0;
      const critica = suscriptor.suscripciones.tipos_incidencias.includes('Crítica') ? 1 : 0;
      const sms = suscriptor.suscripciones.canales.includes('sms') ? 1 : 0;
      const emailCanal = suscriptor.suscripciones.canales.includes('email') ? 1 : 0;

      return {
        id: suscriptor.id,
        email: suscriptor.email,
        telefono: suscriptor.telefono,
        empresa: suscriptor.empresa || null,
        do_not_disturb: !!suscriptor.do_not_disturb,
        emergencia,
        critica,
        sms,
        emailCanal,
        isEditing: false
      };
    },

    mostrarEmpresa(nombre) {
      return nombre || '—';
    },

    async cambiarIncidencia(index, tipo) {
      const suscriptor = this.conjuntoSuscriptores[index];

      if (tipo === 'Emergencia') {
        suscriptor.emergencia = suscriptor.emergencia === 1 ? 0 : 1;
        if (suscriptor.emergencia === 0) {
          suscriptor.critica = 0;
        }
      } else if (tipo === 'Crítica') {
        suscriptor.critica = suscriptor.critica === 1 ? 0 : 1;
        if (suscriptor.critica === 1) {
          suscriptor.emergencia = 1;
        }
      }

      await this.guardarSuscripciones(suscriptor);
    },

    async cambiarCanal(index, canal) {
      const suscriptor = this.conjuntoSuscriptores[index];
      if (canal === 'sms') {
        suscriptor.sms = suscriptor.sms === 1 ? 0 : 1;
      } else {
        suscriptor.emailCanal = suscriptor.emailCanal === 1 ? 0 : 1;
      }
      await this.guardarSuscripciones(suscriptor);
    },

    async guardarSuscripciones(suscriptor) {
      // Regla: Si SMS activo, teléfono obligatorio
      if (suscriptor.sms === 1 && (!suscriptor.telefono || suscriptor.telefono.trim() === '')) {
        this.tituloError = 'Error de validación';
        this.mensajeError = 'El teléfono es obligatorio para activar notificaciones por SMS.';
        this.modalError = true;
        await this.consultarSuscriptores(); // Revertir cambios visuales
        return;
      }

      try {
        const payload = {
          userId: suscriptor.id,
          channels: [
            {name: 'Crítica', active: suscriptor.critica === 1},
            {name: 'Emergencia', active: suscriptor.emergencia === 1}
          ],
          communicationMethods: [
            {name: 'sms', active: suscriptor.sms === 1},
            {name: 'email', active: suscriptor.emailCanal === 1}
          ]
        };

        const response = await fetch(`/api/subscribers/subscriptions`, {
          method: 'PUT',
          headers: auth.getAuthHeader(),
          body: JSON.stringify(payload)
        });

        if (response.status !== 200) {
          const data = await response.json();
          console.error("Error al guardar suscripciones:", data.resultado);
          await this.consultarSuscriptores();
        }
      } catch (error) {
        console.error("Error en guardarSuscripciones:", error);
      }
    },

    cambiarNewIncidencia(tipo) {
      // Aplicar regla de negocio
      if (tipo === 'Emergencia') {
        this.newSuscriptor.emergencia = this.newSuscriptor.emergencia === 1 ? 0 : 1;
        // Si se desactiva Emergencia, también se desactiva Crítica
        if (this.newSuscriptor.emergencia === 0) {
          this.newSuscriptor.critica = 0;
        }
      } else {
        this.newSuscriptor.critica = this.newSuscriptor.critica === 1 ? 0 : 1;
        // Si se activa Crítica, también se activa Emergencia
        if (this.newSuscriptor.critica === 1) {
          this.newSuscriptor.emergencia = 1;
        }
      }
    },

    cambiarNewCanal(canal) {
      if (canal === 'sms') {
        this.newSuscriptor.sms = this.newSuscriptor.sms === 1 ? 0 : 1;
      } else {
        this.newSuscriptor.emailCanal = this.newSuscriptor.emailCanal === 1 ? 0 : 1;
      }
    },

    async consultarSuscriptores() {
      try {
        const url = new URL('/api/subscribers', window.location.origin);
        if (this.emailSearch) url.searchParams.append('email', this.emailSearch);
        if (this.phoneSearch) url.searchParams.append('phone', this.phoneSearch);

        const response = await fetch(url, {
          method: 'GET',
          headers: auth.getAuthHeader()
        });

        const data = await response.json();
        this.conjuntoSuscriptores = data.suscriptores.map(s => this.parsearSuscriptor(s));
      } catch (error) {
        console.error("Error consultando suscriptores:", error);
      }
    },

    async guardar() {
      try {
        // Validaciones básicas
        if (!this.newSuscriptor.email) {
          this.tituloError = 'Error de validación';
          this.mensajeError = 'Por favor, completa el email';
          this.modalError = true;
          return;
        }

        // Regla: Si SMS activo, teléfono obligatorio
        if (this.newSuscriptor.sms === 1 && (!this.newSuscriptor.telefono || this.newSuscriptor.telefono.trim() === '')) {
          this.tituloError = 'Error de validación';
          this.mensajeError = 'El teléfono es obligatorio para activar notificaciones por SMS.';
          this.modalError = true;
          return;
        }

        // Crear suscriptor
        const response = await fetch('/api/subscribers', {
          method: 'POST',
          headers: auth.getAuthHeader(),
          body: JSON.stringify({
            email: this.newSuscriptor.email,
            telefono: this.newSuscriptor.telefono || null
          })
        });

        const data = await response.json();

        if (response.status === 201) {
          const payload = {
            userId: data.id,
            channels: [
              {name: 'Crítica', active: this.newSuscriptor.critica === 1},
              {name: 'Emergencia', active: this.newSuscriptor.emergencia === 1}
            ],
            communicationMethods: [
              {name: 'sms', active: this.newSuscriptor.sms === 1},
              {name: 'email', active: this.newSuscriptor.emailCanal === 1}
            ]
          };

          await fetch(`/api/subscribers/subscriptions`, {
            method: 'PUT',
            headers: auth.getAuthHeader(),
            body: JSON.stringify(payload)
          });

          // Limpiar formulario
          this.newSuscriptor = new Suscriptor(null, null, 0, 0, 0, 0);
          await this.consultarSuscriptores();
        } else {
          this.tituloError = 'Error en la operación';
          this.mensajeError = data.resultado || 'Error al crear suscriptor';
          this.modalError = true;
        }
      } catch (error) {
        console.error("Error creando suscriptor:", error);
        this.tituloError = 'Error en la operación';
        this.mensajeError = 'Error al crear suscriptor';
        this.modalError = true;
      }
    },

    async borrar(item) {
      try {
        const suscriptor = this.conjuntoSuscriptores[item];
        const response = await fetch(`/api/subscribers`, {
          method: 'DELETE',
          headers: auth.getAuthHeader(),
          body: JSON.stringify({
            userId: suscriptor.id
          })
        });

        if (response.status === 200) {
          await this.consultarSuscriptores();
        } else {
          const data = await response.json();
          this.tituloError = 'Error en la operación';
          this.mensajeError = data.resultado || 'Error al eliminar suscriptor';
          this.modalError = true;
        }
      } catch (error) {
        console.error("Error eliminando suscriptor:", error);
        this.tituloError = 'Error en la operación';
        this.mensajeError = 'Error al eliminar suscriptor';
        this.modalError = true;
      }
    },

    cambiarVista(modo) {
      this.viewMode = modo;
    },

    parseJSON(data) {
      try {
        if (typeof data === 'string') {
          return JSON.parse(data);
        }
        return Array.isArray(data) ? data : [];
      } catch (e) {
        return [];
      }
    },

    async consultarSolicitudes() {
      try {
        const response = await fetch(`/api/admin/subscription-requests`, {
          method: 'GET',
          headers: auth.getAuthHeader()
        });
        const data = await response.json();
        if (response.status === 200) {
          this.conjuntoSolicitudes = (data.data || []).filter(req => req.status === 'PENDING').map(req => {
            return {
              ...req,
              parsedChannels: this.parseJSON(req.requested_channels),
              parsedMethods: this.parseJSON(req.requested_methods)
            };
          });
        }
      } catch (error) {
        console.error("Error consultando solicitudes:", error);
      }
    },

    async aprobarSolicitud(id) {
      const solicitud = this.conjuntoSolicitudes.find(r => r.id === id);

      // Regla: Si SMS activo, teléfono obligatorio
      if (solicitud.parsedMethods.includes('sms') && (!solicitud.phone || solicitud.phone.trim() === '')) {
        this.tituloError = 'Error de validación';
        this.mensajeError = 'El teléfono es obligatorio para activar notificaciones por SMS.';
        this.modalError = true;
        return;
      }

      try {
        const response = await fetch(`/api/admin/subscription-requests/approve`, {
          method: 'PATCH',
          headers: auth.getAuthHeader(),
          body: JSON.stringify({
            request_id: id,
            admin_email: localStorage.getItem('userEmail'),
            requested_channels: solicitud.parsedChannels,
            requested_methods: solicitud.parsedMethods
          })
        });
        if (response.status === 200) {
          await this.consultarSolicitudes();
          await this.consultarSuscriptores();
        }
      } catch (error) {
        console.error("Error aprobando solicitud:", error);
      }
    },

    validarCanalesAdmin(req) {
      const hasCritica = req.parsedChannels.includes('Crítica');
      const hasEmergencia = req.parsedChannels.includes('Emergencia');

      if (hasCritica && !hasEmergencia) {
        req.parsedChannels.push('Emergencia');
      }
    },

    prepararRechazo(id) {
      this.idRechazoActivo = id;
      this.motivoRechazo = '';
      this.modalRechazo = true;
    },

    async confirmarRechazo() {
      try {
        const response = await fetch(`/api/admin/subscription-requests/reject`, {
          method: 'PATCH',
          headers: auth.getAuthHeader(),
          body: JSON.stringify({
            request_id: this.idRechazoActivo,
            reason: this.motivoRechazo,
            admin_email: localStorage.getItem('userEmail')
          })
        });
        if (response.status === 200) {
          await this.consultarSolicitudes();
          await this.consultarHistorial();
        }
      } catch (error) {
        console.error("Error rechazando solicitud:", error);
      }
    },

    async consultarHistorial() {
      try {
        const url = new URL('/api/admin/subscription-requests/history', window.location.origin);
        if (this.historyStatusFilter) url.searchParams.append('status', this.historyStatusFilter);
        if (this.historyEmailSearch) url.searchParams.append('email', this.historyEmailSearch);
        if (this.historyPhoneSearch) url.searchParams.append('phone', this.historyPhoneSearch);

        const response = await fetch(url, {
          headers: auth.getAuthHeader()
        });

        const resData = await response.json();
        const total = resData.data || [];

        this.conjuntoHistorial = total.map(req => ({
          ...req,
          parsedChannels: this.parseJSON(req.requested_channels),
          parsedMethods: this.parseJSON(req.requested_methods).map(method =>
              method === 'email' ? 'Email' : method === 'sms' ? 'SMS' : method
          )
        }));

      } catch (error) {
        console.error("Error consultando historial:", error);
      }
    },

    debounce(callback, delay = 500) {
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        callback();
      }, delay);
    },

    async aprobarHistorial(id) {
      // Regla: Si SMS activo, teléfono obligatorio
      if (this.solicitudSeleccionada.parsedMethods.includes('SMS') && (!this.solicitudSeleccionada.phone || this.solicitudSeleccionada.phone.trim() === '')) {
        this.tituloError = 'Error de validación';
        this.mensajeError = 'El teléfono es obligatorio para activar notificaciones por SMS.';
        this.modalError = true;
        return;
      }

      try {
        const response = await fetch(`/api/admin/subscription-requests/approve-rejected`, {
          method: 'PATCH',
          headers: auth.getAuthHeader(),
          body: JSON.stringify({
            request_id: id,
            admin_email: localStorage.getItem('userEmail')
          })
        });
        if (response.status === 200) {
          this.modalDetallesVisible = false;
          await this.consultarHistorial();
          await this.consultarSuscriptores();
        }
      } catch (error) {
        console.error("Error aprobando desde historial:", error);
      }
    },

    abrirModalDetalles(req) {
      this.solicitudSeleccionada = req;
      this.modalDetallesVisible = true;
    },

    formatearFecha(fecha) {
      if (!fecha) return '-';
      return new Date(fecha).toLocaleDateString();
    },

    // --- Métodos de Pánico y Whitelist ---
    async getPanicConfig() {
      try {
        const response = await fetch('/api/admin/config/panic', {
          headers: auth.getAuthHeader()
        });
        const data = await response.json();
        this.panicModeEmail = !!data.panic_mode_email;
        this.panicModeSms = !!data.panic_mode_sms;
      } catch (error) {
        console.error("Error obteniendo config de pánico:", error);
      }
    },

    confirmPanic(channel, value) {
      this.pendingPanicValue = value;
      if (channel === 'email') {
        this.modalPanicEmail = true;
      } else {
        this.modalPanicSms = true;
      }
    },

    async updatePanicConfig(channel) {
      try {
        const payload = {
          panic_mode_email: channel === 'email' ? this.pendingPanicValue : this.panicModeEmail,
          panic_mode_sms: channel === 'sms' ? this.pendingPanicValue : this.panicModeSms
        };

        const response = await fetch('/api/admin/config/panic', {
          method: 'PUT',
          headers: auth.getAuthHeader(),
          body: JSON.stringify(payload)
        });

        if (response.status === 200) {
          if (channel === 'email') this.panicModeEmail = this.pendingPanicValue;
          if (channel === 'sms') this.panicModeSms = this.pendingPanicValue;
        }
      } catch (error) {
        console.error("Error actualizando pánico:", error);
      }
    },

    async getWhitelist() {
      try {
        const response = await fetch('/api/admin/whitelist', {
          headers: auth.getAuthHeader()
        });
        this.conjuntoWhitelist = await response.json();
      } catch (error) {
        console.error("Error obteniendo lista blanca:", error);
      }
    },

    async addToWhitelist() {
      if (!this.newWhitelistEmail) return;
      try {
        const response = await fetch('/api/admin/whitelist', {
          method: 'POST',
          headers: auth.getAuthHeader(),
          body: JSON.stringify({email: this.newWhitelistEmail})
        });

        if (response.status === 200) {
          this.newWhitelistEmail = '';
          await this.getWhitelist();
        } else {
          const data = await response.json();
          this.tituloError = 'Error';
          this.mensajeError = data.error || 'No se pudo añadir el usuario';
          this.modalError = true;
        }
      } catch (error) {
        console.error("Error añadiendo a lista blanca:", error);
      }
    },

    async toggleWhitelistStatus(userId) {
      try {
        const response = await fetch(`/api/admin/whitelist/${userId}/toggle`, {
          method: 'PUT',
          headers: auth.getAuthHeader()
        });
        if (response.status === 200) {
          await this.getWhitelist();
        }
      } catch (error) {
        console.error("Error toggling whitelist status:", error);
      }
    },

    async removeFromWhitelist(userId) {
      if (!confirm('¿Seguro que deseas eliminar a este usuario de la lista blanca?')) return;
      try {
        const response = await fetch(`/api/admin/whitelist/${userId}`, {
          method: 'DELETE',
          headers: auth.getAuthHeader()
        });
        if (response.status === 200) {
          await this.getWhitelist();
        }
      } catch (error) {
        console.error("Error eliminando de lista blanca:", error);
      }
    }
  }
}
</script>

<style scoped>

.orange {
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
  color: white !important;
}

/* ================= Centrar switches ================= */
.switch-centrado :deep(.form-check.form-switch) {
  padding-left: 0 !important;
  margin-bottom: 0 !important;
}

.switch-centrado :deep(.form-check-input) {
  margin-left: 0 !important;
  float: none !important;
  cursor: pointer;
}

/* ================= CSS Botones Naranjas ================= */
.custom-orange-group .btn-primary {
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
  color: white !important;
}

.custom-orange-group .btn-outline-primary {
  color: #ff7300 !important;
  border-color: #ff7300 !important;
  background-color: transparent !important;
}

.custom-orange-group .btn-outline-primary:hover {
  background-color: #ff7300 !important;
  color: white !important;
}

/* ================= CSS Tablas ================= */
.cabecera-agrupada th {
  padding-top: 15px;
  padding-bottom: 5px;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.cabecera-agrupada th.bg-light, .cabecera-agrupada th.bg-channels {
  border-bottom: 2px solid #adb5bd !important;
}

.cabecera-secundaria th {
  border-top: none !important;
}

.espacio-separacion {
  padding-left: 30px !important;
}

.separador-vertical {
  border-left: 2px solid #ccc !important;
}

.bg-channels {
  background-color: #f8f9fa;
}

.text-center {
  text-align: center;
}

#dashboard {
  min-width: 0;
  max-width: 100%;
}

#dashboard > section.row {
  min-width: 0;
  max-width: 100%;
}

#dashboard .col-xl-12 {
  min-width: 0;
  max-width: 100%;
}

@media only screen and (max-width: 992px) {
  .tabla-subcriptores table,
  .tabla-subcriptores thead,
  .tabla-subcriptores tbody,
  .tabla-subcriptores th,
  .tabla-subcriptores td,
  .tabla-subcriptores tr {
    display: block;
  }

  .tabla-subcriptores thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tabla-subcriptores tr {
    border: 1px solid #ccc;
    margin-bottom: 15px;
    background: #fff;
  }

  .tabla-subcriptores td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50% !important;
    white-space: normal;
    text-align: left;
    min-height: 45px;
    display: flex;
    align-items: center;
  }

  .tabla-subcriptores td:before {
    position: absolute;
    top: 50%;
    left: 15px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
    transform: translateY(-50%);
    content: attr(data-title);
  }

  .espacio-separacion {
    padding-left: 50% !important;
  }

  .separador-vertical {
    border-left: none !important;
  }
}

.toggle-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tabla-scroll {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.tabla-scroll > .tabla-subcriptores {
  table-layout: auto;
  width: max-content;
  min-width: 100%;
}

#tabla-suscriptores col:nth-child(1),
#tabla-suscriptores col:nth-child(2),
#tabla-subcriptores-nuevo col:nth-child(1),
#tabla-subcriptores-nuevo col:nth-child(2) {
  width: 75px;
}

#tabla-suscriptores col:nth-child(3),
#tabla-subcriptores-nuevo col:nth-child(3),
#tabla-solicitudes col:nth-child(3),
#tabla-historial col:nth-child(3),
#tabla-whitelist col:nth-child(2) {
  min-width: 22ch;
  width: 30ch;
}

#tabla-suscriptores td:nth-child(3) span {
  display: block;
  max-width: 30ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#tabla-suscriptores col:nth-child(4),
#tabla-subcriptores-nuevo col:nth-child(4),
#tabla-solicitudes col:nth-child(4),
#tabla-historial col:nth-child(4),
#tabla-whitelist col:nth-child(3) {
  width: 150px;
}

#tabla-suscriptores col:nth-child(5) {
  min-width: 18ch;
  width: 18ch;
}

#tabla-suscriptores col:nth-child(6),
#tabla-suscriptores col:nth-child(7),
#tabla-suscriptores col:nth-child(8),
#tabla-suscriptores col:nth-child(9),
#tabla-suscriptores col:nth-child(10),
#tabla-subcriptores-nuevo col:nth-child(5),
#tabla-subcriptores-nuevo col:nth-child(6),
#tabla-subcriptores-nuevo col:nth-child(7),
#tabla-subcriptores-nuevo col:nth-child(8),
#tabla-solicitudes col:nth-child(5),
#tabla-solicitudes col:nth-child(6),
#tabla-solicitudes col:nth-child(7),
#tabla-solicitudes col:nth-child(8) {
  width: 110px;
}

#tabla-solicitudes col:nth-child(1),
#tabla-solicitudes col:nth-child(2),
#tabla-historial col:nth-child(1) {
  min-width: 120px;
}

#tabla-suscriptores .cabecera-secundaria th:nth-child(1),
#tabla-suscriptores .cabecera-secundaria th:nth-child(2),
#tabla-suscriptores .cabecera-secundaria th:nth-child(6),
#tabla-suscriptores .cabecera-secundaria th:nth-child(7),
#tabla-suscriptores .cabecera-secundaria th:nth-child(8),
#tabla-suscriptores .cabecera-secundaria th:nth-child(9),
#tabla-suscriptores .cabecera-secundaria th:nth-child(10),
#tabla-suscriptores td:nth-child(1),
#tabla-suscriptores td:nth-child(2),
#tabla-suscriptores td:nth-child(6),
#tabla-suscriptores td:nth-child(7),
#tabla-suscriptores td:nth-child(8),
#tabla-suscriptores td:nth-child(9),
#tabla-suscriptores td:nth-child(10),
#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(1),
#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(2),
#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(5),
#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(6),
#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(7),
#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(8),
#tabla-subcriptores-nuevo td:nth-child(1),
#tabla-subcriptores-nuevo td:nth-child(2),
#tabla-subcriptores-nuevo td:nth-child(5),
#tabla-subcriptores-nuevo td:nth-child(6),
#tabla-subcriptores-nuevo td:nth-child(7),
#tabla-subcriptores-nuevo td:nth-child(8) {
  text-align: center;
}

.tabla-subcriptores th,
.tabla-subcriptores td {
  white-space: nowrap;
  vertical-align: middle;
}

.tabla-subcriptores td {
  padding: 10px 8px;
}

.tabla-subcriptores :deep(.btn) {
  white-space: nowrap;
}

.tabla-subcriptores :deep(.form-control) {
  margin: 0;
  width: 100%;
  min-width: 12ch;
  height: 38px;
  box-sizing: border-box;
}

@media only screen and (max-width: 992px) {
  .tabla-scroll {
    overflow-x: visible;
    max-width: none;
  }

  .tabla-scroll > .tabla-subcriptores {
    table-layout: auto;
    width: 100%;
    min-width: 0;
  }

  .tabla-subcriptores colgroup {
    display: none;
  }

  .tabla-subcriptores th, .tabla-subcriptores td {
    width: 100% !important;
    white-space: normal;
  }

  .tabla-subcriptores .toggle-container {
    margin-left: 0 !important;
  }

  .tabla-subcriptores td {
    justify-content: flex-start;
  }

  .tabla-subcriptores :deep(.form-control) {
    width: 90%;
    min-width: 0;
  }
}
</style>
